export const socketSagaActions = {
  SET_SOCKET_CONNECTION: 'SET_SOCKET_CONNECTION',
  REMOVE_SOCKET_CONNECTION: 'REMOVE_SOCKET_CONNECTION',
};
